export enum FooterEvent {
  LinkClicked = 'footer-link-clicked',
  DoNotSellClicked = 'do-not-sell-clicked',
  DoNotSellInfoVisible = 'do-not-sell-info-visible',
}
